import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { Section } from './Shared';
import { FlowerOfLife } from './Ornaments';
import { BONUS_TOTAL, MAIN_COVER_URL, bonuses, stats, volumes } from '../data/pack';
export function PackContents() {
  return <Section id="contenido" className="relative" data-id="element-144" data-mp="3m9nok0ao3ji9">
      <FlowerOfLife className="absolute -left-16 top-16 -z-10 h-52 w-52 opacity-25" color="#5FDCD8" data-id="element-145" data-mp="3maf9mh6n1yua" />
      <div className="mx-auto max-w-4xl text-center" data-id="element-146" data-mp="dum04maq5nmq">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-brand-gold/55 bg-brand-paper px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-brand-goldDark shadow-sm" data-id="element-147" data-mp="it6ui53apd39">
          <BookOpenIcon className="h-3.5 w-3.5 text-brand-goldDark" aria-hidden="true" data-id="element-148" data-mp="922ed21vvm6u" />
          Mirá el atlas por dentro
        </span>
        <h2 className="mt-3 font-display text-2xl font-bold leading-tight text-brand-ink sm:text-3xl md:text-4xl" data-id="element-149" data-mp="11j51siz9r25u">
          Sin vaguedades místicas ni teoría interminable:{' '}
          <span className="-rotate-1 inline-block rounded-md bg-brand-gold px-2 py-0.5 leading-tight text-brand-deep" data-id="element-150" data-mp="3p51ouocu8ihc">
            la geometría exacta
          </span>
          , la imagen anatómica, la técnica precisa.
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl items-center gap-8 rounded-3xl border border-brand-violet/30 bg-brand-paper/85 p-5 shadow-[0_16px_48px_rgba(8,4,20,0.45)] md:grid-cols-[0.75fr_1.25fr] md:p-8" data-id="element-151" data-mp="3u5g0egdneak4">
        <div className="light-plinth mx-auto w-full max-w-[280px] rounded-2xl border border-brand-gold/35 p-3" data-id="element-152" data-mp="6sls5y14l44l">
          <img src={MAIN_COVER_URL} alt="Portada del Atlas de Geometría Sagrada Aplicada al Cuerpo, manual clínico de arquitectura energética y gemoterapia anatómica" loading="lazy" decoding="async" className="mx-auto h-auto w-full object-contain" data-id="element-153" data-mp="lq5u0w2q6j6j" />
        </div>
        <div data-id="element-154" data-mp="3873964sq2xl2">
          <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-brand-violet" data-id="element-155" data-mp="387d323gw1ow1">
            El pack principal
          </span>
          <h3 className="mt-1 font-display text-xl font-bold leading-tight text-brand-ink md:text-2xl" data-id="element-156" data-mp="3c96x3swkvun8">
            ATLAS DE GEOMETRÍA SAGRADA APLICADA AL CUERPO™
          </h3>
          <p className="mt-3 max-w-lg font-serif text-lg leading-snug text-brand-text" data-id="element-157" data-mp="3m7w4usurfypr">
            Tu sistema visual completo para diagnosticar con precisión,
            intervenir con redes de cristales y sellar con pases energéticos
            maestros.
          </p>
          <div className="mt-5 grid grid-cols-4 divide-x divide-brand-gold/30 rounded-2xl border border-brand-gold/40 bg-brand-surfaceLight/70 px-2 py-3 text-center" data-id="element-158" data-mp="3t561stljpy5">
            {stats.map(stat => <div key={stat.label} className="px-1" data-id="element-159" data-mp="drkv7q92cp50">
                <strong className="block font-display text-lg leading-none text-brand-teal" data-id="element-160" data-mp="dsvw9ib4jisf">
                  {stat.value}
                </strong>
                <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.1em] text-brand-muted" data-id="element-161" data-mp="238pxyn0co7rv">
                  {stat.label}
                </span>
              </div>)}
          </div>
          <p className="mt-4 text-sm leading-relaxed text-brand-muted" data-id="element-162" data-mp="1tb203o7g6k5h">
            Localización exacta del bloqueo, cristal indicado, pase de
            corrección y sellado de protección en una consulta rápida.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-10 grid max-w-5xl gap-4 md:grid-cols-3" data-id="element-163" data-mp="2m0ing7g7nauu">
        {volumes.map(volume => <article key={volume.number} className="flex h-full flex-col rounded-2xl border border-brand-violet/25 bg-brand-paper/80 p-5" data-id="element-164" data-mp="2c8uzigiv4by4">
            <div className="mx-auto w-full max-w-[170px] overflow-hidden rounded-lg border border-brand-gold/35 shadow-[0_10px_24px_rgba(36,28,60,0.22)]" data-id="element-165" data-mp="277p9wrki14st">
              <img src={volume.cover} alt={`Portada del ${volume.number}: ${volume.title}`} loading="lazy" decoding="async" className="aspect-[2/3] h-full w-full object-cover" data-id="element-166" data-mp="2zxebb614f6uy" />
            </div>
            <h4 className="mt-4 font-display text-sm font-bold leading-tight text-brand-ink" data-id="element-167" data-mp="2aj1kwc0662zv">
              <span className="text-brand-violet" data-id="element-168" data-mp="2fgtcf4wwjn3j">{volume.number}</span> —{' '}
              {volume.title}
            </h4>
            <p className="mt-2 text-[13px] leading-relaxed text-brand-muted" data-id="element-169" data-mp="3388hv6jz6kj0">
              {volume.description}
            </p>
          </article>)}
      </div>

      <div className="mt-14 text-center" data-id="element-170" data-mp="2thnlzqvoru3s">
        <h3 className="flex flex-wrap items-center justify-center gap-2 font-display text-xl font-bold text-brand-ink md:text-2xl" data-id="element-171" data-mp="2tgkuphugbpnc">
          <GiftIcon className="h-5 w-5 text-brand-goldDark" aria-hidden="true" data-id="element-172" data-mp="3m5ruek5n6la6" />
          6 BONOS ESTRATÉGICOS —<span className="text-brand-teal" data-id="element-173" data-mp="3qwi0jzlw6s5x">GRATIS</span>
        </h3>
      </div>
      <div className="mx-auto mt-7 grid max-w-6xl grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-174" data-mp="3qyl0bbcujznu">
        {bonuses.map(bonus => <article key={bonus.n} className="flex min-w-0 flex-col" data-id="element-175" data-mp="1aiy2wz9yo3pn">
            <div className="overflow-hidden rounded-lg border border-brand-gold/40 shadow-[0_10px_26px_rgba(8,4,20,0.5)]" data-id="element-176" data-mp="1aglmwrnrk3f8">
              <img src={bonus.cover} alt={`Portada del bono ${bonus.n}: ${bonus.title}`} loading="lazy" decoding="async" className="aspect-[3/4] h-full w-full object-cover" data-id="element-177" data-mp="1k8hjtze45nhv" />
            </div>
            <p className="mt-2 text-center text-[10px] font-bold uppercase leading-tight tracking-wide text-brand-violet" data-id="element-178" data-mp="15jd54s6j21ei">
              {bonus.title}
            </p>
            <p className="mt-1 min-h-[3.5rem] text-center text-[10px] leading-tight text-brand-muted" data-id="element-179" data-mp="11ggeqfaqx100">
              {bonus.description}
            </p>
            <p className="mt-auto pt-2 text-center text-[10px] text-brand-muted" data-id="element-180" data-mp="2cxg7td4x3jv3">
              <span className="line-through" data-id="element-181" data-mp="19m9eqdo7qh4q">{bonus.price}</span>{' '}
              <strong className="text-brand-teal" data-id="element-182" data-mp="19o3px09omuvm">→ GRATIS</strong>
            </p>
          </article>)}
      </div>
      <div className="mt-7 text-center" data-id="element-183" data-mp="1jk710vmii3up">
        <span className="inline-block rounded-full border border-brand-gold/50 bg-brand-paper px-5 py-3 text-sm font-medium text-brand-text shadow-[0_10px_26px_rgba(8,4,20,0.4)]" data-id="element-184" data-mp="1jl8awwrskkau">
          Valor total de los bonos{' '}
          <span className="text-brand-muted line-through" data-id="element-185" data-mp="qxck28owlmlz">{BONUS_TOTAL}</span>{' '}
          <strong className="text-brand-teal" data-id="element-186" data-mp="vve3wvu5lpyi">
            → GRATIS con tu Atlas de Geometría
          </strong>
        </span>
      </div>
    </Section>;
}